//import { User, WebStorageStateStore } from "oidc-client-ts";
import { User } from "oidc-client-ts";
import { appAuthUrl, appRealm } from "./constants";

// temp:commnet out the following block ..this is becuase there is an issue in the refresh token we will fix later

// //const appEnv = process.env.REACT_APP_ENV as keyof KeycloakEnv;
// // In-memory storage implementation
// class InMemoryStorage implements Storage {
//   private storage: { [key: string]: string } = {};

//   get length(): number {
//     return Object.keys(this.storage).length;
//   }

//   clear(): void {
//     this.storage = {};
//   }

//   getItem(key: string): string | null {
//     return this.storage[key] || null;
//   }

//   key(index: number): string | null {
//     const keys = Object.keys(this.storage);
//     return keys[index] || null;
//   }

//   removeItem(key: string): void {
//     delete this.storage[key];
//   }

//   setItem(key: string, value: string): void {
//     this.storage[key] = value;
//   }
// }

// const onSigninCallback = (_user: User | void): void => {
//   // Clean up URL without causing a reload
//   if (window.location.search || window.location.hash) {
//     window.history.replaceState(
//       {},
//       document.title,
//       window.location.pathname
//     );
//   }
// }

// // Custom metadata to handle auth_time issues
// // const getMetadata = async () => {
// //   const response = await fetch(`${envKC[appEnv].authServerUrl}/realms/${envKC[appEnv].realm}/.well-known/openid_configuration`);
// //   const metadata = await response.json();
// //   return metadata;
// // }

// export const oidcConfig: any = {
//   authority: `${appAuthUrl}/realms/${appRealm}`,
//   client_id: "wildfire-admin-app",
//   redirect_uri: `${window.location.origin}${window.location.pathname}`, // Use origin + pathname, not full href
//   post_logout_redirect_uri: `${window.location.origin}/logged-out`,
//   silent_redirect_uri: `${window.location.origin}/silent-renew.html`, // For silent token renewal
//   pkce_method: "S256",
//   extraQueryParams: {
//     kc_idp_hint: "oidc"
//   },
//   // Automatic refresh token configuration - DISABLED for manual control
//   automaticSilentRenew: false, // Disable automatic renewal to control it manually
//   silentRequestTimeoutInSeconds: 30, // Timeout for silent renewal requests
//   accessTokenExpiringNotificationTimeInSeconds: (60), // 1 minute before expiration 
  
//   // Token storage - use in-memory storage (more secure)
//   userStore: new WebStorageStateStore({ store: new InMemoryStorage() }), // Store tokens in memory only
  
//   // Scopes to request refresh tokens
//   scope: "openid profile email offline_access", // offline_access is required for refresh tokens
  
//   // Settings to prevent app reloads during refresh
//   loadUserInfo: false, // Don't load user info automatically to reduce requests
//   monitorSession: false, // Disable session monitoring to prevent reloads
//   includeIdTokenInSilentRenew: true, // Include ID token in silent renewal
//   revokeAccessTokenOnSignout: true, // Clean up properly on signout
  
//   // Fix auth_time validation issues - CRITICAL SETTINGS
//   validateSubOnSilentRenew: false, // Disable subject validation on silent renewal
//   clockSkew: 300, // Allow 5 minutes clock skew
  
//   // Additional settings to handle auth_time issues
//   silentRenewTimeout: 300000, // 30 seconds
//   filterProtocolClaims: true, // Filter out protocol claims that might cause issues
  
//   // Disable strict validations that cause auth_time issues
//   // responseType: "code", // Use authorization code flow
//   staleStateAgeInSeconds: 900, // 15 minutes for stale state cleanup
//   onSigninCallback
// };



const onSigninCallback = (_user: User | void): void => {
     window.history.replaceState(
         {},
         document.title,
         window.location.pathname
     )
}

export const oidcConfig: any = {
  authority: `${appAuthUrl}/realms/${appRealm}`,
  client_id: "wildfire-admin-app",
  //redirect_uri: window.location.href,
  redirect_uri: `${window.location.origin}${window.location.pathname}`, // Use origin + pathname, not full href
  post_logout_redirect_uri: `${window.location.origin}/logged-out`,
  scope: `openid profile email offline_access`,
  pkce_method: "S256",
  extraQueryParams: {
    kc_idp_hint: "oidc"
  },
  silentRequestTimeoutInSeconds: 30, // Timeout for silent renewal requests
  accessTokenExpiringNotificationTimeInSeconds: (3*60),   // Number of seconds before the token expires to trigger the `tokenExpiring` event .. the defualt is 60 sec
  onSigninCallback
};

